// extracted by mini-css-extract-plugin
export default {"title":"TitleLogin_title__GFY-1"};